/* eslint-disable class-methods-use-this */

import React from "react";

import { gaEventNoHit } from "../../shared/helpers/gtm_tracking";

class NoResultsBumper extends React.PureComponent {
  componentDidMount() {
    const eventCategory = this.props.pageType;
    const eventAction = "No results";
    const eventLabel = location.pathname + location.search;

    gaEventNoHit(eventCategory, eventAction, eventLabel);
  }

  renderBody() {
    const { fallbackNumber, fallbackNumberHref } = this.props;

    return (
      <button
        type="button"
        data-component="cta-button"
      >
        <a
          className="gtm-track-click js-ellipsis js-ellipsis-href"
          href={`tel:${fallbackNumberHref}`}
          data-gtm-category="Search Page"
          data-gtm-action="No Results Bumper"
          data-gtm-label="Phone"
          data-icon=""
        >
          {fallbackNumber}
        </a>
      </button>
    );
  }

  renderFooter() {
    return (
      <footer>
        <p>
          <small>
            Not available to chat?
            <button
              className="gtm-track-click"
              type="button"
              data-component="cta-linkbutton"
              data-gtm-category="Search Page"
              data-gtm-action="No Results Bumper"
              data-gtm-label="General enquiry"
              data-toggle="modal"
              data-target="#js-general-enquiry-modal"
            >
              Request a call back
            </button>
          </small>
        </p>
      </footer>
    )
  }

  renderHeader() {
    const { props } = this;
    const { place } = props.params;
    const title = `Sorry, we can't find a package for ${props.regionName || place} on your selected date`;

    return (
      <header>
        <h3 id="aria-callout-box-title">
          <i className="fa fa-info-circle" aria-hidden="true"></i>
          {title}
        </h3>
        <p>
          Please try another date, or alternatively, call our Golf Experts who can create
          a fully customised package for you for any date in less than 60 seconds!
        </p>
      </header>
    );
  }

  render() {
    return (
      <article data-component="callout-box">
        {this.renderHeader()}

        {this.renderBody()}

        {this.renderFooter()}
      </article>
    );
  }
}

export default NoResultsBumper;



// WEBPACK FOOTER //
// ./components/search/NoResultsBumper.jsx